/* eslint-disable @typescript-eslint/no-explicit-any */
import { Express } from "express";
import { RequestHandler } from "express-serve-static-core";

import { NotFoundWebError } from "./NotFoundWebError";
import { IParamBinder } from "./ParamBinders/IParamBinder";
import { IResultHandler } from "./Results/IResultHandler";

const routesProperty = "__http_routes__";

export function httpGet(
    urlPattern: string | RegExp,
    resultHandler: IResultHandler,
    ...paramConfigs: IParamBinder[]
): MethodDecorator {
    return (instanceClass, propertyKey) => {
        // @ts-ignore
        instanceClass[routesProperty] = instanceClass[routesProperty] || [];

        function setupBinding(instance: any, expressApp: Express): void {
            expressApp.get(urlPattern, buildHandler(instance, propertyKey, paramConfigs, resultHandler));
        }

        // @ts-ignore
        instanceClass[routesProperty].push(setupBinding);
    };
}

export function httpPost(
    urlPattern: string,
    resultHandler: IResultHandler,
    ...paramConfigs: IParamBinder[]
): MethodDecorator {
    return (instanceClass, propertyKey) => {
        // @ts-ignore
        instanceClass[routesProperty] = instanceClass[routesProperty] || [];

        function setupBinding(instance: any, expressApp: Express): void {
            expressApp.post(urlPattern, buildHandler(instance, propertyKey, paramConfigs, resultHandler));
        }

        // @ts-ignore
        instanceClass[routesProperty].push(setupBinding);
    };
}

export function httpSetupAttributeRouting<T>(instance: T, expressApp: Express): void {
    // @ts-ignore
    for (const route of instance[routesProperty] || []) {
        route(instance, expressApp);
    }
}

function buildHandler(
    instance: any,
    methodName: string | symbol,
    paramConfigs: IParamBinder[],
    resultHandler: IResultHandler
): RequestHandler {
    return async (req, res, next) => {
        try {
            const params = paramConfigs.map(x => x.extractValue(req));
            // eslint-disable-next-line prefer-spread
            let result = instance[methodName].apply(instance, params);
            if (typeof result.then === "function") {
                result = await result;
            }
            await resultHandler.processResult(result, req, res);
        } catch (e) {
            if (e instanceof NotFoundWebError) {
                next();
            } else if (e instanceof Error) {
                res.status(500).send(`${e.message}\n${e.stack}`);
            } else {
                res.status(500).send(`${e}`);
            }
        }
    };
}
